/* tslint:disable */
/* eslint-disable */
/**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DebondingDelegation,
    DebondingDelegationFromJSON,
    DebondingDelegationFromJSONTyped,
    DebondingDelegationToJSON,
    DebondingDelegationListAllOf,
    DebondingDelegationListAllOfFromJSON,
    DebondingDelegationListAllOfFromJSONTyped,
    DebondingDelegationListAllOfToJSON,
    List,
    ListFromJSON,
    ListFromJSONTyped,
    ListToJSON,
} from './';

/**
 * 
 * @export
 * @interface DebondingDelegationList
 */
export interface DebondingDelegationList {
    /**
     * The total number of records that match the query, i.e. the number of records
     * the query would return with limit=infinity.
     * @type {number}
     * @memberof DebondingDelegationList
     */
    total_count: number;
    /**
     * Whether total_count is clipped for performance reasons.
     * @type {boolean}
     * @memberof DebondingDelegationList
     */
    is_total_count_clipped: boolean;
    /**
     * 
     * @type {Array<DebondingDelegation>}
     * @memberof DebondingDelegationList
     */
    debonding_delegations: Array<DebondingDelegation>;
}

export function DebondingDelegationListFromJSON(json: any): DebondingDelegationList {
    return DebondingDelegationListFromJSONTyped(json, false);
}

export function DebondingDelegationListFromJSONTyped(json: any, ignoreDiscriminator: boolean): DebondingDelegationList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'total_count': json['total_count'],
        'is_total_count_clipped': json['is_total_count_clipped'],
        'debonding_delegations': ((json['debonding_delegations'] as Array<any>).map(DebondingDelegationFromJSON)),
    };
}

export function DebondingDelegationListToJSON(value?: DebondingDelegationList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total_count': value.total_count,
        'is_total_count_clipped': value.is_total_count_clipped,
        'debonding_delegations': ((value.debonding_delegations as Array<any>).map(DebondingDelegationToJSON)),
    };
}


